import React, { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faPlay, faXmark } from "@fortawesome/free-solid-svg-icons";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || "").split(",").pop() || "");
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const formatSize = (bytes) => {
  if (!bytes) return "";
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  if (bytes >= 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${bytes} B`;
};

const resolveFileIcon = (file) => {
  const mimeType = String(file?.mimeType || "").toLowerCase();
  if (mimeType.startsWith("audio/") || mimeType.startsWith("video/")) {
    return faPlay;
  }
  return faFileLines;
};

export default function EvidenceUploader({ files = [], onChange, disabled = false }) {
  const inputRef = useRef(null);

  const onSelectFiles = async (event) => {
    const selected = Array.from(event.target.files || []);
    if (!selected.length) return;

    const mapped = [];
    for (const file of selected) {
      const contenidoBase64 = await toBase64(file);
      mapped.push({
        nombreArchivo: file.name,
        mimeType: file.type || "application/octet-stream",
        contenidoBase64,
        tipo: file.type?.startsWith("audio/")
          ? "AUDIO"
          : file.type?.startsWith("image/")
            ? "IMAGEN"
            : "ARCHIVO",
        tamanoBytes: file.size,
      });
    }

    onChange?.([...(files || []), ...mapped]);
    event.target.value = "";
  };

  return (
    <section className="process-action-modal-v2__section">
      <div className="process-action-modal-v2__evidence-toolbar">
        <div className="process-action-modal-v2__section-copy">
          <h3 className="process-action-modal-v2__section-title">Evidencias nuevas</h3>
          <p>Archivos png, jpg, jpeg, pdf, mp3, wav, m4a.</p>
        </div>

        <Button
          type="button"
          className="process-action-modal-v2__upload-btn"
          disabled={disabled}
          onClick={() => inputRef.current?.click()}
        >
          + Subir archivos
        </Button>
      </div>

      <Form.Control ref={inputRef} type="file" multiple hidden onChange={onSelectFiles} />

      {!!files?.length && (
        <div className="process-action-modal-v2__evidence-list">
          {files.map((file, index) => (
            <div key={`${file.nombreArchivo}-${index}`} className="process-action-modal-v2__file-row">
              <div className="process-action-modal-v2__file-main">
                <span className="process-action-modal-v2__file-icon" aria-hidden="true">
                  <FontAwesomeIcon icon={resolveFileIcon(file)} />
                </span>
                <div>
                  <div className="process-action-modal-v2__file-name">{file.nombreArchivo}</div>
                  <div className="process-action-modal-v2__file-size">{formatSize(file.tamanoBytes)}</div>
                </div>
              </div>

              <button
                type="button"
                className="process-action-modal-v2__file-remove"
                disabled={disabled}
                onClick={() => onChange?.(files.filter((_, itemIndex) => itemIndex !== index))}
                aria-label={`Quitar ${file.nombreArchivo}`}
              >
                <FontAwesomeIcon icon={faXmark} />
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
